module.exports = __webpack_public_path__ + "static/media/confetti.252b63d8.png";